 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLEPAGE from '@/components/Text/Titlepage'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTDEDICATION from '@/components/Text/Dedication'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXTPREFACE from '@/components/Text/Preface'
 import TEXTENTRIES from '@/components/Text/Entries'
 import TEXTSECTION0001 from '@/components/Text/Section0001'
 import TEXTSECTION0002 from '@/components/Text/Section0002'
 import TEXTSECTION0003 from '@/components/Text/Section0003'
 import LOVE_2 from '@/components/love_2'
 import TEXTAFTERWORD from '@/components/Text/Afterword'
 import TEXTCTA from '@/components/Text/CTA'
 import TEXTINDEX from '@/components/Text/Index'
 import TEXTKEVINSULLIVAN_BUNDYBOOKS_V2 from '@/components/Text/KevinSullivan_BundyBooks_v2'
 import TEXTKEVINSULLIVAN_OTHERBOOKS_V1 from '@/components/Text/KevinSullivan_OtherBooks_v1'
 import TEXTTRAILOFTEDBUNDY_EXCERPTAD from '@/components/Text/TRAILOFTEDBUNDY_ExcerptAd'
 import TEXTGARDENSTATE_EXCERPT from '@/components/Text/GARDENSTATE_Excerpt'
 import TEXTTRUECRIMEADPAGE3 from '@/components/Text/TrueCrime-AdPage3'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/Preface",
 			"name" : "Text/Preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/Entries",
 			"name" : "Text/Entries",
 			"component" : TEXTENTRIES
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js